// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referralTable {
  /* width: 100%; */
  /* height: 593px; */
  box-shadow: -6px 10px 40px 0px #00000014;
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0.5) -1.68%,
      rgba(255, 255, 255, 0.1) 100%);
  border: 1px solid #ffffff;
  border-radius: 10px;
  padding: 28px;

  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wallet-address {
  font-size: 18px;
}

/* data  not found */
/* .data_not {
  text-align: center;
  margin-top: 27px;
  position: absolute;
  left: 0;
  right: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: Quicksand;

} */

.data_not {
  text-align: center;
  font-weight: bold;
  padding: 20px;
}


.referralTable>h1 {
  color: #000000;
  font-weight: 600;
  font-size: 24px;
}

.responsiveTableParent {
  height: 100%;
  overflow-y: auto;
  border-radius: 6px;
}

.responsiveTableParent>div:first-child {
  border-radius: 6px;
}

.responsiveTableParent::-webkit-scrollbar {
  width: 3px;
  display: none;
}

/* Track */
.responsiveTableParent::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.responsiveTableParent::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}

/* Handle on hover */
.responsiveTableParent::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.referralTable>div>input {
  background: #eaf4fe;
  border: 1px solid #234b9a;
  outline: none;
  padding: 8.5px 12px;
  width: 41%;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #000000;
  height: 40px;
}

.filtertablebtn ul {
  min-width: 120px;
  background-color: #f3f7ff;
  color: #000000;
  border: 1px solid #234b9a;
}

.filtertablebtn ul>li {
  margin: 2px 6px;
}

.filtertablebtn {
  border: 1px solid #234b9a;
  border-radius: 4px;
  color: #234b9a;
  cursor: pointer;
}

.filtertablebtn>button {
  width: 100%;
  height: 100%;
  padding: 8px 24px;
  outline: none;
  border: none;
  color: #234b9a;
  font-weight: 500;
  border-radius: inherit;
  background-color: transparent;
  text-transform: uppercase;
}

.filtertablebtn img {
  width: 18px;
  height: 20px;
  margin-right: 1rem;
}


.dropdown-item:focus,
.dropdown-item:hover {
  color: #000000;
  background-color: #dfe9fd;
  border-radius: 4px;
}

.affTableHeader {
  background: linear-gradient(90deg, #77a5ff 0%, #cfdfff 40.5%, #77a5ff 100%);
  border-radius: 0px 4px 4px 0px;
}

.table> :not(caption)>*>* {
  background-color: transparent;
}

.affTableHeader {
  height: 56px;
}

.table>thead {
  vertical-align: middle;
}

.affTableHeader tr>th {
  padding: 8px 16px;
}

/* Table Pagination Css */
.AffTxTableButton {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
}

.AffTxTableButton button {
  border: 1px solid #e84427;
  outline: none;
  border-radius: 6px;
  width: 3rem;
  height: 2rem;
  background: transparent;
  padding: 4px;
  font-weight: 500;
  font-size: 16px;
  color: #515151;
  display: flex;
  align-items: center;
  justify-content: center;
}

.AffTxTableButton button:hover {
  border-width: 2px !important;
  font-weight: 700;
}

.referralTableBody {
  position: relative;
}

.referralTableBody>tr>td {
  padding: 16px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.referralTableBody>tr:hover {
  background-color: #eceaea;
}

.referralTableBody>tr>td:last-child {
  cursor: pointer;
}

/* Referral Details Css */

.referralDetails_container {
  width: 100%;
  height: fit-content;
}

.refferal_header {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}

.referral_mainBox {
  width: 100%;
  border-radius: 14px;
  background: linear-gradient(180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0.1) 100%);
  border: 1px solid #ffffff;
  box-shadow: -6px 10px 40px 0px #00000014;
  padding: 15px 15px;
}

.Affi_walletAddress>div:last-child {
  font-size: 14px;
  font-weight: 400;
  transition: 0.3s ease-in-out;
}

.Affi_walletAddress {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  font-size: 20px;
  color: #000000;
}

.Affi_walletAddress>span:first-child {
  font-weight: 500;
}

.Affi_walletAddress>span:last-child {
  font-weight: 600;
}

.refferal_header>p:first-child {
  width: fit-content;
  cursor: pointer;
}

.Affi_dataBox {
  background: #1d70d21a;
  padding: 16px 16px;
  font-size: 16px;
  color: #000000;
  border-radius: 8px;
}

.Affi_dataBox>span:first-child {
  font-weight: 500;
}

.Affi_dataBox>span:last-child {
  font-weight: 600;
}

/* @media screen and (max-width: 576px) {
  .filtertablebtn {
    width: 100%;
  }
} */

.wallet-addr {
  font-size: 20px;
  color: #000000;
  font-weight: 600;
  /* padding: 10px 16px; */
}

.referral-hei {
  height: 20rem;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px;
}

.button-end {
  margin: 0px 0px 0px auto;
}

.leadership-hei {
  height: 100vh;
}

.disabled-button {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-button:hover {
  cursor: not-allowed;
}


@media screen and (max-width: 768px) {
  .affTableHeader tr>th {
    font-size: 12px;
  }

  .referralTableBody>tr>td {
    font-size: 12px;
  }

  .Affi_dataBox {
    font-size: 12px;
  }

  .button-end {
    margin: unset;
  }

  .button-end-2 {
    margin: 0 auto;
  }

  .referral_mainBox>div>:last-child {
    margin-top: 1rem;
  }
}

@media screen and (min-width: 769px) and (max-width: 900px) {
  .affTableHeader tr>th {
    font-size: 14px;
  }

  .referralTableBody>tr>td {
    font-size: 12px;
  }

  .Affi_dataBox {
    font-size: 12px;
  }

  .tnxhtrbdytbl>tr>td {
    font-size: 12px;
  }

  .tnxHistoryheader>tr>th {
    font-size: 12px;
  }
}

.headerWithOutlet{
  box-sizing: content-box;
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Referral/Referral.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC;;oCAEkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;;;;;;;;;;GAUG;;AAEH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;;EAEE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2EAA2E;EAC3E,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;;AAEzB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB;;oCAEkC;EAClC,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;IACrB,cAAc;AAClB","sourcesContent":[".referralTable {\n  /* width: 100%; */\n  /* height: 593px; */\n  box-shadow: -6px 10px 40px 0px #00000014;\n  background: linear-gradient(90deg,\n      rgba(255, 255, 255, 0.5) -1.68%,\n      rgba(255, 255, 255, 0.1) 100%);\n  border: 1px solid #ffffff;\n  border-radius: 10px;\n  padding: 28px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wallet-address {\n  font-size: 18px;\n}\n\n/* data  not found */\n/* .data_not {\n  text-align: center;\n  margin-top: 27px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  font-size: 20px;\n  font-weight: 700;\n  font-family: Quicksand;\n\n} */\n\n.data_not {\n  text-align: center;\n  font-weight: bold;\n  padding: 20px;\n}\n\n\n.referralTable>h1 {\n  color: #000000;\n  font-weight: 600;\n  font-size: 24px;\n}\n\n.responsiveTableParent {\n  height: 100%;\n  overflow-y: auto;\n  border-radius: 6px;\n}\n\n.responsiveTableParent>div:first-child {\n  border-radius: 6px;\n}\n\n.responsiveTableParent::-webkit-scrollbar {\n  width: 3px;\n  display: none;\n}\n\n/* Track */\n.responsiveTableParent::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.responsiveTableParent::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 2px;\n}\n\n/* Handle on hover */\n.responsiveTableParent::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.referralTable>div>input {\n  background: #eaf4fe;\n  border: 1px solid #234b9a;\n  outline: none;\n  padding: 8.5px 12px;\n  width: 41%;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #000000;\n  height: 40px;\n}\n\n.filtertablebtn ul {\n  min-width: 120px;\n  background-color: #f3f7ff;\n  color: #000000;\n  border: 1px solid #234b9a;\n}\n\n.filtertablebtn ul>li {\n  margin: 2px 6px;\n}\n\n.filtertablebtn {\n  border: 1px solid #234b9a;\n  border-radius: 4px;\n  color: #234b9a;\n  cursor: pointer;\n}\n\n.filtertablebtn>button {\n  width: 100%;\n  height: 100%;\n  padding: 8px 24px;\n  outline: none;\n  border: none;\n  color: #234b9a;\n  font-weight: 500;\n  border-radius: inherit;\n  background-color: transparent;\n  text-transform: uppercase;\n}\n\n.filtertablebtn img {\n  width: 18px;\n  height: 20px;\n  margin-right: 1rem;\n}\n\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n  color: #000000;\n  background-color: #dfe9fd;\n  border-radius: 4px;\n}\n\n.affTableHeader {\n  background: linear-gradient(90deg, #77a5ff 0%, #cfdfff 40.5%, #77a5ff 100%);\n  border-radius: 0px 4px 4px 0px;\n}\n\n.table> :not(caption)>*>* {\n  background-color: transparent;\n}\n\n.affTableHeader {\n  height: 56px;\n}\n\n.table>thead {\n  vertical-align: middle;\n}\n\n.affTableHeader tr>th {\n  padding: 8px 16px;\n}\n\n/* Table Pagination Css */\n.AffTxTableButton {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 7px;\n}\n\n.AffTxTableButton button {\n  border: 1px solid #e84427;\n  outline: none;\n  border-radius: 6px;\n  width: 3rem;\n  height: 2rem;\n  background: transparent;\n  padding: 4px;\n  font-weight: 500;\n  font-size: 16px;\n  color: #515151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.AffTxTableButton button:hover {\n  border-width: 2px !important;\n  font-weight: 700;\n}\n\n.referralTableBody {\n  position: relative;\n}\n\n.referralTableBody>tr>td {\n  padding: 16px 16px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n}\n\n.referralTableBody>tr:hover {\n  background-color: #eceaea;\n}\n\n.referralTableBody>tr>td:last-child {\n  cursor: pointer;\n}\n\n/* Referral Details Css */\n\n.referralDetails_container {\n  width: 100%;\n  height: fit-content;\n}\n\n.refferal_header {\n  font-size: 24px;\n  font-weight: 600;\n  color: #000000;\n}\n\n.referral_mainBox {\n  width: 100%;\n  border-radius: 14px;\n  background: linear-gradient(180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0.1) 100%);\n  border: 1px solid #ffffff;\n  box-shadow: -6px 10px 40px 0px #00000014;\n  padding: 15px 15px;\n}\n\n.Affi_walletAddress>div:last-child {\n  font-size: 14px;\n  font-weight: 400;\n  transition: 0.3s ease-in-out;\n}\n\n.Affi_walletAddress {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-start;\n  font-size: 20px;\n  color: #000000;\n}\n\n.Affi_walletAddress>span:first-child {\n  font-weight: 500;\n}\n\n.Affi_walletAddress>span:last-child {\n  font-weight: 600;\n}\n\n.refferal_header>p:first-child {\n  width: fit-content;\n  cursor: pointer;\n}\n\n.Affi_dataBox {\n  background: #1d70d21a;\n  padding: 16px 16px;\n  font-size: 16px;\n  color: #000000;\n  border-radius: 8px;\n}\n\n.Affi_dataBox>span:first-child {\n  font-weight: 500;\n}\n\n.Affi_dataBox>span:last-child {\n  font-weight: 600;\n}\n\n/* @media screen and (max-width: 576px) {\n  .filtertablebtn {\n    width: 100%;\n  }\n} */\n\n.wallet-addr {\n  font-size: 20px;\n  color: #000000;\n  font-weight: 600;\n  /* padding: 10px 16px; */\n}\n\n.referral-hei {\n  height: 20rem;\n}\n\n.box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  padding: 10px;\n}\n\n.button-end {\n  margin: 0px 0px 0px auto;\n}\n\n.leadership-hei {\n  height: 100vh;\n}\n\n.disabled-button {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.disabled-button:hover {\n  cursor: not-allowed;\n}\n\n\n@media screen and (max-width: 768px) {\n  .affTableHeader tr>th {\n    font-size: 12px;\n  }\n\n  .referralTableBody>tr>td {\n    font-size: 12px;\n  }\n\n  .Affi_dataBox {\n    font-size: 12px;\n  }\n\n  .button-end {\n    margin: unset;\n  }\n\n  .button-end-2 {\n    margin: 0 auto;\n  }\n\n  .referral_mainBox>div>:last-child {\n    margin-top: 1rem;\n  }\n}\n\n@media screen and (min-width: 769px) and (max-width: 900px) {\n  .affTableHeader tr>th {\n    font-size: 14px;\n  }\n\n  .referralTableBody>tr>td {\n    font-size: 12px;\n  }\n\n  .Affi_dataBox {\n    font-size: 12px;\n  }\n\n  .tnxhtrbdytbl>tr>td {\n    font-size: 12px;\n  }\n\n  .tnxHistoryheader>tr>th {\n    font-size: 12px;\n  }\n}\n\n.headerWithOutlet{\n  box-sizing: content-box;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
